import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import React from "react";
import styled from "styled-components";
import { Box, Card } from "@origin-digital/layout";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { TickList } from "../components/TickList";
import { slideInAnimation } from "../components/CommonStyles";
import { Dismiss } from "../components/Dismiss";
import { Image } from "../components/Image";
export var CardContainer = styled(Card).withConfig({
  displayName: "ExperimentCardNBA__CardContainer",
  componentId: "sc-1sff25g-0"
})(["", ""], slideInAnimation);
var Content = styled.div.withConfig({
  displayName: "ExperimentCardNBA__Content",
  componentId: "sc-1sff25g-1"
})(["overflow-x:hidden;"]);
export var ExperimentCardNBA = function ExperimentCardNBA(props) {
  var content = props.content,
      onHide = props.onHide;
  return React.createElement(CardContainer, null, React.createElement(Dismiss, _extends({}, props, {
    onHide: onHide
  })), React.createElement(Box, {
    display: "flex",
    direction: "column",
    width: "100%",
    height: "100%"
  }, React.createElement(Header, props), React.createElement(Box, {
    display: "flex",
    direction: "row",
    width: "100%"
  }, React.createElement(Content, null, React.createElement(TickList, {
    content: content
  }), React.createElement(Footer, props)), React.createElement(Image, {
    imageSha: content.imageSha
  }))));
};